import { createApi } from '@reduxjs/toolkit/query/react';
import {
  TGetTierGearBuSlotQuery,
  TGetTierTalentsQuery,
  TGetTierTrinketsQuery,
  TTierGearBySlotResponse,
  TTierTalentsResponse,
  TTierTrinketsResponse
} from '../../../../../../shared/types/statisticsTypes';
import { networkBaseQuery } from '../../services/api/utils';

export const specStatisticsApi = createApi({
  reducerPath: 'specStatisticsApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    getTierTalentsData: builder.query<TTierTalentsResponse, TGetTierTalentsQuery>({
      query: (params) => ({ url: '/api/statistics/tier/talents', params })
    }),
    getTierGearData: builder.query<TTierGearBySlotResponse, TGetTierGearBuSlotQuery>({
      query: (params) => ({ url: '/api/statistics/tier/gear', params })
    }),
    getTierTrinketsData: builder.query<TTierTrinketsResponse, TGetTierTrinketsQuery>({
      query: (params) => ({ url: '/api/statistics/tier/trinkets', params })
    })
  })
});

export const { useGetTierTalentsDataQuery, useGetTierGearDataQuery, useGetTierTrinketsDataQuery } = specStatisticsApi;
